import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { MaterialModule } from '@angular/material';
import { ReactiveFormsModule } from '@angular/forms';
import { DataTableModule } from 'primeng/primeng';
import { FlexLayoutModule } from '@angular/flex-layout';
import { GroupComponent } from './group.component';
import { GroupListComponent } from './grouplist/group-list.component';
import { AddGroupComponent } from './addgroup/add-group.component';
import { MultiSelectModule } from 'primeng/primeng';
import { ListboxModule } from 'primeng/primeng';
@NgModule({
    declarations: [GroupComponent, GroupListComponent, AddGroupComponent],
    imports: [
        MaterialModule.forRoot(),
        ReactiveFormsModule,
        BrowserModule,
        FormsModule,
        DataTableModule,
        FlexLayoutModule,
        MultiSelectModule,
        ListboxModule
    ],
    providers: [],
    entryComponents: [
        AddGroupComponent
    ]
})

/**
 * Main module for the group managements.
 *
 * @author pankaj.khurana@vernuso.com (Pankaj Khurana)
*/

export class GroupModule { }





// WEBPACK FOOTER //
// ./src/app/admin/groups/group.module.ts